// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 4701 ? "svg-icons" : chunkId) + "." + {"61":"c2adb3ad","481":"43cf6ca2","735":"89fde4a5","4701":"91ac0f0e","6118":"9cd5cb2e"}[chunkId] + ".chunk.js";
};